"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findClauseInExpression = exports.findClauseInLibrary = void 0;
/**
 * Find an ELM clause by localId in a given library.
 *
 * @param library The library to search in.
 * @param localId The localId to look for.
 * @returns The expression if found or null.
 */
function findClauseInLibrary(library, localId) {
    for (var i = 0; i < library.library.statements.def.length; i++) {
        var statement = library.library.statements.def[i];
        var expression = findClauseInExpression(statement.expression, localId);
        if (expression) {
            return expression;
        }
    }
    return null;
}
exports.findClauseInLibrary = findClauseInLibrary;
/**
 * Recursively search an ELM tree for an expression (clause) with a given localId.
 *
 * @param expression The expression tree to search for the clause in.
 * @param localId The localId to look for.
 * @returns The expression if found or null.
 */
function findClauseInExpression(expression, localId) {
    if (typeof expression === 'string' || typeof expression === 'number' || typeof expression === 'boolean') {
        return null;
    }
    else if (Array.isArray(expression)) {
        for (var i = 0; i < expression.length; i++) {
            var memberExpression = findClauseInExpression(expression[i], localId);
            if (memberExpression) {
                return memberExpression;
            }
        }
        return null;
    }
    else if (expression.localId == localId) {
        return expression;
    }
    else {
        return findClauseInExpression(Object.values(expression), localId);
    }
}
exports.findClauseInExpression = findClauseInExpression;
//# sourceMappingURL=ELMHelpers.js.map